import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";

function Signup() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    confirmEmail: "",
    password: "",
    confirmPassword: "",
    phone: "",
    address: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSignup = (e) => {
    e.preventDefault();

    if (form.email !== form.confirmEmail) {
      alert("Email does not match");
      return;
    }

    if (form.password !== form.confirmPassword) {
      alert("Password does not match");
      return;
    }

    localStorage.setItem("user", JSON.stringify(form));
    alert("Signup Successful!");
    navigate("/login");
  };

  return (
    <form onSubmit={handleSignup}>
      <h2>Signup</h2>

      <input name="firstName" placeholder="First Name" onChange={handleChange} required />
      <br />

      <input name="lastName" placeholder="Last Name" onChange={handleChange} required />
      <br />

      <input type="email" name="email" placeholder="Email" onChange={handleChange} required />
      <br />

      <input type="email" name="confirmEmail" placeholder="Confirm Email" onChange={handleChange} required />
      <br />

      <input type="password" name="password" placeholder="Password" onChange={handleChange} required />
      <br />

      <input type="password" name="confirmPassword" placeholder="Confirm Password" onChange={handleChange} required />
      <br />

      <input name="phone" placeholder="Phone Number" onChange={handleChange} required />
      <br />

      <input name="address" placeholder="Address" onChange={handleChange} required />
      <br />

      <button type="submit">Signup</button>

      <p>
        You have account? <Link to="/login">Login</Link>
      </p>
    </form>
  );
}

export default Signup;
